import { ReportSummaryData } from '@modules/dynamicReports/ReportForms';
import { PageQuery } from '../common';
import { GraphTypes } from '../graph';

export enum DateRangeTypes {
  today = 'today',
  yesterday = 'yesterday',
  last7 = 'last7',
  last30 = 'last30',
  month = 'month',
  lastMonth = 'lastMonth',
  year = 'year',
  lastYear = 'lastYear',
}

export const DateRangeTypesMap: Record<DateRangeTypes, string> = {
  today: 'Today',
  yesterday: 'Yesterday',
  last7: 'Last 7 days',
  last30: 'Last 30 days',
  month: 'This month',
  lastMonth: 'Last month',
  year: 'This year',
  lastYear: 'Last year',
};
export enum FieldMappingType {
  string = 'string',
  number = 'number',
  currency = 'currency',
  date = 'date',
  boolean = 'boolean',
}
export enum FieldMappingOverlayType {
  order = 'order',
}

export interface FieldMapping {
  name: string;
  key: string;
  type: FieldMappingType;
  isArray: boolean;
  isCustomField?: boolean;
  isPrivate: boolean;
  canTotal: boolean;
  description?: string;
  link: string;
  duration: string;
  filterItems: { [key: string]: string };
  overlay: {
    field?: string;
    type?: FieldMappingOverlayType;
  };
}
export interface ReportDataSource {
  name: string;
  view: string;
  mapping: { [key: string]: FieldMapping };
  icon: string;
  description: string;
  reports: string[];
  isGraph: boolean;
  graphType: GraphTypes;
  group: string;
  /** Set on a user-created source that has been deleted; filtered out of every picker. */
  deleted?: boolean;
}

export type ReportDataType = Record<string, string | number | boolean>;

export interface ReportDataQuery extends PageQuery {
  request?: ReportDataRequest;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  filters?: { [key: string]: string[] | string };
  dateRange?: string;
  isFooter?: boolean;
  widgetId?: string;
}

export interface ReportAdditionalData {
  summary: number[];
  totals?: { [key: string]: number };
}

export interface ReportDataRequest {
  source: string;
  groupBy?: string;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  columns: ReportColumn[];
  filters: ReportFilter[];
  dateColumn?: string;
  snapshotDateColumn?: string;
  detailed?: boolean;
  detailedColumns?: string[];
  detailFilter?: string | number | boolean;
  summary?: ReportSummaryData[];
  search?: string;
}

export enum ColumnGroupType {
  none = 'none',
  sum = 'sum',
  min = 'min',
  max = 'max',
  comma = 'group_concat',
  avg = 'avg',
  count = 'count',
}

export enum FormatType {
  auto = 'auto',
  number = 'number',
  currency = 'currency',
  percentage = 'percentage',
  duration = 'duration',
  hours = 'hours',
  minutes = 'minutes',
}
export interface ReportColumn {
  name: string;
  label: string;
  groupBy: ColumnGroupType;
  menuOrder: number;
}

export interface ReportFilter {
  name: string;
  operator: string;
  value: string | string[];
}

export enum ValueGroupOp {
  contains = 'contains',
  is = 'is',
}

export enum UnmatchedBehaviour {
  other = 'other',
  hide = 'hide',
}

export interface ValueGroupRule {
  op: ValueGroupOp;
  value: string;
}

export interface ValueGroup {
  label: string;
  rules: ValueGroupRule[];
}

export interface ValueGrouping {
  unmatched: UnmatchedBehaviour;
  unmatchedLabel: string;
  groups: ValueGroup[];
}
